// ─────────────────────────────────────────────────────────────────────────────
// Module-internal config values of the products module.
// ─────────────────────────────────────────────────────────────────────────────

export const PROMOTIONS_CATEGORY_ID = 'promotions'
export const PROMOTIONS_CATEGORY_NAME = 'Promocje'

export const UNCATEGORIZED_CATEGORY_ID = 'uncategorized'
export const UNCATEGORIZED_CATEGORY_NAME = 'Pozostałe'
